import { ReactElement } from 'react'
import { Flexbox } from '../../components/flexbox/flexbox'
import { ScreenTitle } from '../../components/screen-title/screen-title'
import DepositForm from '../../forms/deposit-form'
import { depositsState } from '../../states/deposits-state'
import { useRecoilValue } from 'recoil'
import { DepositItem } from '../../components/deposits-list/deposit-item'
import { EditModeContext } from '../../utils/edit-mode-context'

const DepositsScreen = (): ReactElement => {
  const deposits = useRecoilValue(depositsState)

  return (
    <EditModeContext.Provider value={true}>
      <Flexbox flex={1} isCol>
        <ScreenTitle title={'Deposits'} />
        <table className="table table-compact w-full">
          <thead>
            <tr>
              <th>Date</th>
              <th>Amount</th>
              <th>Account</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {deposits.map((item) => (
              <DepositItem
                id={item.id}
                realizedAt={item.realizedAt}
                amount={item.amount}
                currencyCode={item.currency?.code}
                showId={false}
                accountName={item.account?.name}
              />
            ))}
          </tbody>
        </table>

        {deposits.length === 0 && 'No deposits yet'}
        <h2 className="text-2xl font-bold uppercase pb-4 pt-8">New Deposit</h2>
        <DepositForm />
      </Flexbox>
    </EditModeContext.Provider>
  )
}

export default DepositsScreen